module.exports = __webpack_public_path__ + "static/media/visa_rounded.f96d8a45.svg";